import {
  Component,
  OnInit,
  TemplateRef,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { CILMasterService } from 'src/app/services/cil-master-service';
import { ToastrService } from 'ngx-toastr';
import { RMconfigurationService } from 'src/app/services/rmconfiguration.service';
import { ManagerExecutionService } from 'src/app/services/manager.service';
import { UserManagementService } from 'src/app/services/usermanagement.service';
import { MatDialog } from '@angular/material/dialog';
import { ScheduleTaskDialogComponent } from './schedule-task-dialog/schedule-task-dialog.component';
import { prevTaskService } from 'src/app/services/prev-task.service';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { PrevConfigurationService } from 'src/app/services/prev-configuration.service';
import { DatePipe } from '@angular/common';
import { EnterPriseGroupService } from 'src/app/services/enterpriseGroup.service';
import { CommonService } from 'src/app/services/common.service';
import { TranslaterService } from 'src/app/services/translater.service';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import 'ag-grid-enterprise';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine-dark.css';
import { BaseApi } from 'src/backend/api/base-api';
import { ApplicationPermission } from 'src/app/user-management/shared/models/application-permission';
import { EmployeeService } from 'src/backend/services/user-access-services/employee.service';
import { RescheduleTaskDialogComponent } from './reschedule-task-dialog/reschedule-task-dialog.component';
import moment from 'moment';
import { MatSelect } from '@angular/material/select';
@Component({
  selector: 'app-schedule-task',
  templateUrl: './schedule-task.component.html',
  styleUrls: ['./schedule-task.component.scss'],
})
export class ScheduleTaskComponent implements OnInit {
  @ViewChild('pmTaskForm') private pmTaskForm!: TemplateRef<any>;
  @ViewChild('fileInput') fileInput!: ElementRef;
  languageDir = 'ltr';
  langObj: any = {};
  moduleId!: any;
  pageId!: any;
  groupList: any = [];
  filteredGroupList: any = [];
  plantList: any = [];
  filteredPlantList: any = [];
  technicianList: any = [];
  filteredTechnicianList: any = [];
  userList: any = [];
  breadcrumList: any = [];
  spinnerText: string = '';
  headerData: any = {
    group: '',
    plant: '',
    technician: 'ALL',
    WeekMonth: 2,
  };
  monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];
  weekNames = ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'];
  taskList: any = [];
  taskPoolList: any = [];
  filterTaskList: any = [];
  taskColumns: string[] = [
    'Sno',
    'Machine',
    'Task Name',
    'Description',
    'Frequency',
    'Activity',
    'Duration',
  ];
  scheduleTaskColumns: any = [];
  weekScheduleTaskColumns: any = [];
  currentMonth: string = '';
  selectedYear: number;
  currentYear: number = 0;
  calTypeList: any = [
    { id: 1, value: 'Week' },
    { id: 2, value: 'Month' },
  ];
  taskRow: any = [];
  weekIndex: number = 0;
  isAdmin: boolean = false;
  PMTask: any = {
    Group: '',
    Plant: '',
    line: null,
    units: null,
    assembly: null,
    subAssembly: null,
    component: null,
    lineName: '',
    unitName: '',
    assemblyName: '',
    subAssemblyName: '',
    componentName: '',
    Description: '',
    Technician: '',
    Frequency: '',
    displayMachine: '',
    Duration: '',
    SpareParts: '',
    UploadFile: '',
    TaskType: '',
    MaintenanceType: '',
    FromTaskDate: new Date(),
    FileType: [],
    CreatedAt: '',
    CreatedBy: 0,
    ID: 0,
  };
  PMTaskForm: any;
  HeaderForm!: FormGroup;
  TechnicianList: any = [];
  orgUserList: any = [];
  filterTechnicianList: any = [];
  WOTypeList: any = [];
  frequencyList: any = [];
  TaskTypeList: any = [];
  FreqDuration: any;
  unitPickerIsOpen: boolean = false;
  isPickFromUnit: boolean = false;
  imageSrc = new Array<string>();
  fileType: any;
  FileData: any = [];
  FileList: any = [];
  user: any;
  permisson!: any;
  selectedFilter = 'ALL';
  MaintenanceType: any = [
    { ID: 1, Name: 'Time Based' },
    { ID: 2, Name: 'Condition Based' },
  ];
  TaskStatusList: any = [
    { ID: 1, Name: 'Live' },
    { ID: 2, Name: 'Active' },
  ];
  TaskStatusListFiltered: any[] = this.TaskStatusList.slice();
  groupFiltList: any;
  plantFiltList: any;
  WOTypeFiltList: any;
  WOTypeListHeaderForm: any;
  WOTypeFiltListHeaderForm: any;
  TechnicianFiltList: any;
  FrequencyFiltList: any;
  TaskTypeFiltList: any;
  filteredCalTypeList: any[] = this.calTypeList.slice();
  currentDate = new Date();
  LineList: any = [];
  LineFilterList: any = [];
  LineAllList: any = [];
  UnitList: any = [];
  UnitFilterList: any = [];
  UnitAllList: any = [];
  AssemblyList: any = [];
  AssemblyFilterList: any = [];
  AssemblyAllList: any = [];
  SubAssemblyList: any = [];
  SubAssemblyFilterList: any = [];
  SubAssemblyAllList: any = [];
  ComponentList: any = [];
  ComponentFilterList: any = [];
  ComponentAllList: any = [];
  TechnicianList1: any;
  TechnicianListFilter: any;
  FrequencyList: any;
  FrequencyFiterList: any;
  TaskTypeList1: any;
  TaskTypeFilterList: any;
  WOTypeList1: any;
  WOTypeFilterList: any;
  lang: any;
  isAccess = ApplicationPermission.SCHEDULE_TASK_ACCESS;
  isWrite = ApplicationPermission.SCHEDULE_TASK_CREATE;
  isUpdate = ApplicationPermission.SCHEDULE_TASK_UPDATE;
  isDelete = ApplicationPermission.SCHEDULE_TASK_DELETE;
  plantSession: any;
  groupSession: any;
  userSession: any;
  yearList: number[] = [];
  columnDefs!: any[];
  gridApi: any;
  gridColumnApi: any;
  rowData: any[] = [];
  rowPoolData: any[] = [];
  gridOptions: any = {
    defaultColDef: {
      rowStyle: {
        'border-bottom': 'white 10px solid',
        'border-top': 'white 10px solid',
        'max-height': '50px',
      },
      paginationPageSize: 5,
      infiniteInitialRowCount: 2,
      flex: 1,
      sortable: true,
      resizable: true,
      wrapText: true,
      filter: 'agSetColumnFilter',
      floatingFilterComponentParams: {
        suppressFilterButton: false,
      },
      filterParams: { newRowsAction: 'keep' },
    },
    popupParent: document.querySelector('body'),
    onFirstDataRendered: (params: any) => {
      params.columnApi.autoSizeAllColumns();
    },
    onGridSizeChanged: (params: any) => {
      params.columnApi.autoSizeAllColumns();
    },
    rowSelection: 'multiple',
  };
  selectedRowCount: any;
  public minDate: moment.Moment | undefined;
  public maxDate: moment.Moment | undefined;

  machineList: any[] = [];
  componentList: any[] = [];
  typeList: any[] = [];

  filteredMachineList: string[] = [];
  filteredComponentList: string[] = [];
  filteredTaskList: any[] = [];
  filteredFrequencyList: string[] = [];
  filteredTypeList: string[] = [];
  taskTypeList: string[] = [];
  filteredTaskTypeList: string[] = [];

  allUnitList: any;
  filteredAllUnitList: any;
  allComponentList: any;
  filteredAllComponentList: any;
  allTaskList: any[] = [];
  filteredAllTaskList: any;
  allFrequencyList: any;
  filteredAllFrequencyList: any;

  lineList: any[] = [];
  filteredLineList: any[] = [];

  constructor(
    public translater: TranslaterService,
    public translate: TranslateService,
    private fb: FormBuilder,
    public router: Router,
    private spinner: NgxSpinnerService,
    private toaster: ToastrService,
    private rmConfigurationService: RMconfigurationService,
    private prevTaskService: prevTaskService,
    public dialog: MatDialog,
    private RMConfigurationService: RMconfigurationService,
    private PrevConfigurationService: PrevConfigurationService,
    public datePipe: DatePipe,
    private baseApi: BaseApi,
    private prevConfigurationService: PrevConfigurationService,
    private employeeService: EmployeeService
  ) {
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      event.lang === 'ar'
        ? (this.languageDir = 'rtl')
        : (this.languageDir = 'ltr');
      this.getLangWords();
    });
    this.PMTaskForm = this.fb.group({
      group: ['', Validators.required],
      plant: ['', Validators.required],
      line: new FormControl('', [Validators.required]),
      unit: new FormControl('', [Validators.required]),
      assembly: new FormControl(''),
      subAssembly: new FormControl(''),
      component: new FormControl(''),
      description: ['', Validators.required],
      technicians: ['', Validators.required],
      frequency: ['', Validators.required],
      WOType: ['', Validators.required],
      type_duration: ['', Validators.required],
      spare_part: ['', Validators.required],
      task_type: ['', Validators.required],
      maintenanceType: ['', Validators.required],
      fromTaskDate: ['', Validators.required],
    });

    this.HeaderForm = this.fb.group({
      technician: new FormControl(null),
      dateRange: new FormControl(null),
      endDate: new FormControl(null),
      line: new FormControl([]),
      machine: new FormControl([]),
      component: new FormControl([]),
      task: new FormControl([]),
      frequency: new FormControl([]),
      type: new FormControl([]),
      activity: new FormControl([]),
      taskStatus: new FormControl([]),
      taskType: new FormControl([]),
      userTechnician: new FormControl([]),
      year: new FormControl(null),
      curmonth: new FormControl(null),
      wkmonth: new FormControl(null),

    });

    this.columnDefs = [
      {
        headerName: 'Action',
        headerCheckboxSelection: true,
        checkboxSelection: true,
        width: 50,
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Line',
        field: 'line.plDesc',
        filter: 'agSetColumnFilter',
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Machine',
        field: 'units.puDesc',
        filter: 'agSetColumnFilter',
        headerValueGetter: this.localizeHeader.bind(this),
        // filterParams: {
        //   values: params => this.getMachineFilterValues(params),
        //   newRowsAction: 'keep'
        // }
      },
      {
        headerName: 'Component',
        field: 'component.componentName',
        filter: 'agSetColumnFilter',
        headerValueGetter: this.localizeHeader.bind(this),
        // filterParams: {
        //   values: params => this.getComponentFilterValues(params),
        //   newRowsAction: 'keep'
        // }
      },
      {
        headerName: 'Task',
        field: 'Description',
        filter: 'agSetColumnFilter',
        headerValueGetter: this.localizeHeader.bind(this),

        // filterParams: {
        //   values: params => this.getTaskFilterValues(params),
        //   newRowsAction: 'keep'
        // }
      },
      {
        headerName: 'TaskType',
        field: 'TaskType.Name',
        filter: 'agSetColumnFilter',
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Task Type',
        field: 'WOType.Name',
        filter: 'agSetColumnFilter',
        headerValueGetter: this.localizeHeader.bind(this),

        // filterParams: {
        //   values: params => this.getTypeFilterValues(params),
        //   newRowsAction: 'keep'
        // }
      },
      {
        headerName: 'Duration',
        field: 'Duration',
        // filter: 'agSetColumnFilter',
      },
      {
        headerName: 'Frequency',
        field: 'Frequency.Name',
        filter: 'agSetColumnFilter',
        headerValueGetter: this.localizeHeader.bind(this),

        // filterParams: {
        //   values: params => this.getFrequencyFilterValues(params),
        //   newRowsAction: 'keep'
        // }
      },

      {
        headerName: 'Schedule',
        field: 'TaskStatus',
        filter: 'agSetColumnFilter',
        cellStyle: (params: any) => {
          switch (params.value) {
            case 'Live':
              return {
                backgroundColor: 'green',
                color: 'white',
                fontWeight: 'bold',
              };
            case 'Active':
              return {
                backgroundColor: 'yellow',
                color: 'black',
                fontWeight: 'bold',
              };
            case 'InActive':
              return {
                backgroundColor: 'red',
                color: 'white',
                fontWeight: 'bold',
              };
            default:
              return {};
          }
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },

      {
        headerName: 'Earliest Schedule',
        field: 'Earlier_Schedule',
        filter: 'agDateColumnFilter',
        headerValueGetter: this.localizeHeader.bind(this),
        valueFormatter: (params) =>
          this.datePipe.transform(params.value, 'dd-MM-yyyy') || '',
        filterParams: {
          comparator: (filterLocalDateAtMidnight: Date, cellValue: string) => {
            const dateAsString = this.datePipe.transform(
              cellValue,
              'dd-MM-yyyy'
            );
            const dateParts = dateAsString?.split('-');
            if (dateParts) {
              const cellDate = new Date(
                Number(dateParts[2]),
                Number(dateParts[1]) - 1,
                Number(dateParts[0])
              );
              if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
                return 0;
              }
              if (cellDate < filterLocalDateAtMidnight) {
                return -1;
              }
              if (cellDate > filterLocalDateAtMidnight) {
                return 1;
              }
            }
            return 0;
          },
        },
      },

      {
        headerName: 'Technician',
        field: 'Technician',
        filter: 'agSetColumnFilter',
        headerValueGetter: this.localizeHeader.bind(this),
        valueGetter: (params) => {
          const technicianIds = (params.data.Technician || '')
            .split(',')
            .map((id) => id.trim());

          const technicianNames = technicianIds.map((id) => {
            const technician = this.technicianList.find(
              (t) => t.employeeCode === id
            );
            return technician ? technician.fullName : id; // fallback to ID if not found
          });

          return technicianNames.join(', ');
        },
      },

      {
        headerName: 'From Task Date',
        field: 'StartDate',
        filter: 'agDateColumnFilter',
        headerValueGetter: this.localizeHeader.bind(this),
        valueFormatter: (params) =>
          this.datePipe.transform(params.value, 'dd-MM-yyyy') || '',
      },
      {
        headerName: 'To Task Date',
        field: 'EndDate',
        filter: 'agDateColumnFilter',
        headerValueGetter: this.localizeHeader.bind(this),
        valueFormatter: (params) =>
          this.datePipe.transform(params.value, 'dd-MM-yyyy') || '',
      },
    ];
  }

  ngOnInit(): void {
    this.plantSession = this.baseApi.getPlantFromStorage();
    this.groupSession = this.baseApi.getGroupFromStorage();
    this.userSession = this.baseApi.getUserSession();
    this.getLangWords();
    this.user = this.userSession?.userCode;
    this.initializeYearList();
    this.selectedYear = new Date().getFullYear();
    this.headerData.technician = 'ALL';
    this.currentMonth = this.monthNames[new Date().getMonth()];
    this.getUserList();
    this.selectedRowCount = 0;
    this.getFrequency();
    this.getTaskType();
    // this.GetUnitList();
    this.GetLineByPlant();
    this.getTaskList();
    this.getPMTechnicianTaskPool();

    this.taskList = [];
    this.filteredTaskList = [];

    // this.GetComponentList();
  }

  GetLineByPlant() {
    this.spinner.show();
    const key = { UserId: this.userSession?.userCode };
    this.PrevConfigurationService.GetLineByPlant(key).subscribe(
      (res: any) => {
        this.lineList = res;
        this.filteredLineList = res;
        this.spinner.hide();
      },
      (error: any) => {
        this.spinner.hide();
        this.toaster.error('Error', error.message);
      }
    );
  }

  GetUnitsByLineId(lineId: any) {
    this.spinner.show();
    const key = { LineId: lineId };
    this.PrevConfigurationService.GetUnitsByLineId(key).subscribe(
      (res: any) => {
        this.machineList = res;
        this.filteredMachineList = res;
        this.spinner.hide();
      },
      (error: any) => {
        this.spinner.hide();
        this.toaster.error('Error', error.message);
      }
    );
  }

  //  GetUnitList() {
  //   this.spinner.show();
  //   const key = { PlantCode: this.plantSession?.plantCode };
  //   this.PrevConfigurationService.GetUnitByPlant(key).subscribe(
  //     (res: any) => {
  //       this.machineList = res;
  //       this.filteredMachineList = res;
  //       this.spinner.hide();
  //     },
  //     (error: any) => {
  //       this.spinner.hide();
  //       this.toaster.error('Error', error.message)
  //     },
  //   );
  // }

  GetComponentList(puId: string) {
    this.spinner.show();
    const key = { puId: puId };
    this.PrevConfigurationService.GetComponentByUnit(key).subscribe(
      (res: any) => {
        this.componentList = res;
        this.filteredComponentList = res;
        this.spinner.hide();
      },
      (error: any) => {
        this.spinner.hide();
        this.toaster.error('Error', error.message);
      }
    );
  }

  getMachineFilterValues(params: any) {
    const uniqueValues = [
      ...new Set(
        this.rowData.map((item) => item.Task?.units?.puId).filter(Boolean)
      ),
    ];
    params.success(uniqueValues);
  }

  getComponentFilterValues(params: any) {
    const uniqueValues = [
      ...new Set(
        this.rowData
          .map((item) => item.Task?.component?.componentId)
          .filter(Boolean)
      ),
    ];
    params.success(uniqueValues);
  }

  getTaskFilterValues(params: any) {
    const uniqueValues = [
      ...new Set(
        this.rowData.map((item) => item.Task?.Description).filter(Boolean)
      ),
    ];
    params.success(uniqueValues);
  }

  getFrequencyFilterValues(params: any) {
    const uniqueValues = [
      ...new Set(
        this.rowData.map((item) => item.Task?.Frequency?.Name).filter(Boolean)
      ),
    ];
    params.success(uniqueValues);
  }

  getTypeFilterValues(params: any) {
    const uniqueValues = [
      ...new Set(
        this.rowData.map((item) => item.Task?.WOType?.Name).filter(Boolean)
      ),
    ];
    params.success(uniqueValues);
  }

  public localizeHeader(parameters: any) {
    let headerIdentifier = parameters.colDef.headerName;
    return this.getTransalatedValue(headerIdentifier);
  }

  getTransalatedValue(value: string) {
    let val;
    if (this.langObj && this.langObj[value]) {
      val = this.langObj[value];
    }
    return val ? val : value;
  }

  onGridReady(params: any): any {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.sizeColumnsToFit();
    this.autoSizeAllColumns();
  }

  autoSizeColumns(params: any): void {
    const allColumns = params.columnApi.getAllColumns();
    const columnState = params.columnApi.getColumnState();

    params.columnApi.autoSizeAllColumns();

    allColumns.forEach((column: any) => {
      const columnWidth = column.getActualWidth();
      const maxWidth = 300;
      if (columnWidth > maxWidth) {
        params.columnApi.getColumnState().forEach((state: any) => {
          if (state.colId === column.getColId()) {
            state.width = maxWidth;
          }
        });
      }
    });
    params.columnApi.applyColumnState({ state: columnState, applyOrder: true });
  }

  loadTechnicianList(): void {
    if (this.gridOptions.api) {
      this.gridOptions.api.refreshCells({ force: true });
    }
  }

  autoSizeAllColumns() {
    this.gridApi.setRowData(this.rowData);
    this.gridColumnApi.autoSizeAllColumns();
  }

  cellClicked(params: any): void {
    const col = params.colDef.field;
    // if (col == 'UploadPicture' || col == 'techExc.AfterPicture') {
    //   this.image = params && params.value ? params.value : '';
    //   if (this.image != '') this.openPictureBeforeModal();
    // }
  }

  onRowSelectionChange() {
    const selectedRows = this.gridOptions.api.getSelectedRows();
    this.selectedRowCount = selectedRows.length;
    const selectedRowIds = selectedRows.map((row) =>
      row.Task ? row.Task.ID : null
    );
  }

  initializeYearList() {
    const currentYear = new Date().getFullYear();
    const startYear = 2000;
    const endYear = currentYear + 50;
    for (let year = startYear; year <= endYear; year++) {
      this.yearList.push(year);
    }
  }

  //date formatter
  dateAsYYYYMMDDHHNNSS(date: any): string {
    return (
      date.getFullYear() +
      '-' +
      this.leftpad(date.getMonth() + 1, 2) +
      '-' +
      this.leftpad(date.getDate(), 2) +
      ' ' +
      this.leftpad(date.getHours(), 2) +
      ':' +
      this.leftpad(date.getMinutes(), 2) +
      ':' +
      this.leftpad(date.getSeconds(), 2)
    );
  }
  leftpad(val: any, resultLength = 2, leftpadChar = '0'): string {
    return (String(leftpadChar).repeat(resultLength) + String(val)).slice(
      String(val).length
    );
  }

  updateSchedule(taskRow: number, column: number) {
    this.taskList[taskRow].pmAcList[column].hour =
      this.taskList[taskRow].Duration;
    this.taskList[taskRow].occupaied = true;
  }

  onPanelClose(isOpen: boolean, type: string, inputElement: HTMLInputElement) {
    if (!isOpen) {
      // Reset the search input value
      inputElement.value = '';

      // Restore the filtered list to its original state
      switch (type) {
        case 'line':
          this.filteredLineList = [...this.lineList];
          break;
        case 'machine':
          this.filteredMachineList = [...this.machineList];
          break;
        case 'component':
          this.filteredComponentList = [...this.componentList];
          break;
        case 'task':
          this.filteredTaskList = [...this.taskList];
          break;
        case 'frequency':
          this.filteredFrequencyList = [...this.frequencyList];
          break;
        case 'activity':
          this.WOTypeFiltListHeaderForm = [...this.WOTypeListHeaderForm];
          break;
        case 'taskStatus':
          this.TaskStatusListFiltered = [...this.TaskStatusList];
          break;
        case 'tech':
          this.filteredTechnicianList = [...this.technicianList];
          break;
        case 'type':
          this.filteredTypeList = [...this.TaskTypeList];
          break;
      }
    }
  }

  focusSelect(select: MatSelect) {
    select.focus();
  }

  getWeek() {
    const now = new Date();
    let selectedMonth: any = this.monthNames.findIndex(
      (mnth: any) => mnth == this.currentMonth
    );
    const days = new Date(now.getFullYear(), selectedMonth + 1, 0).getDate();
    let scheduleTaskColumns: any = [];
    this.currentYear = now.getFullYear();
    let currentDayAdded: any = 0;
    let currentDay = selectedMonth == now.getMonth() ? now.getDay() : 1;
    let currentDate = now.getDate();
    for (let i = 1; i <= days; i++) {
      const fullDate = new Date();
      fullDate.setFullYear(this.currentYear);
      fullDate.setMonth(selectedMonth);
      fullDate.setDate(i);

      let column: any = { date: 0, day: '', weekOff: false };
      column.date = i;
      column.weekOff = currentDay == 5 || currentDay == 6 ? true : false;
      if (i == currentDate) {
        column.day = this.weekNames[currentDay - 1];
        currentDayAdded = true;
        currentDay++;
      } else if (currentDayAdded != 0 && currentDayAdded) {
        if (currentDay > 7) currentDay = 1;
        column.day = this.weekNames[currentDay - 1];
        currentDay++;
      }
      column.fullDate = fullDate;
      scheduleTaskColumns.push(column);
    }
    currentDay = now.getDay();
    for (let i = currentDate; i > 0; i--) {
      const fullDate = new Date();
      fullDate.setFullYear(this.currentYear);
      fullDate.setMonth(selectedMonth);
      fullDate.setDate(i);

      let column: any = { date: 0, day: '', weekOff: false };
      column.date = i;
      column.weekOff = currentDay == 5 || currentDay == 6 ? true : false;
      if (currentDay <= 0) currentDay = 7;
      column.day = this.weekNames[currentDay - 1];
      currentDay--;
      column.fullDate = fullDate;
      scheduleTaskColumns[i - 1] = column;
    }
    if (scheduleTaskColumns && scheduleTaskColumns.length)
      scheduleTaskColumns.map((schd: any) => (schd.task = []));

    if (this.taskList && this.taskList.length) {
      for (const task of this.taskList) {
        const scheduleDate = new Date(task.TaskExpireTime);
        const date = scheduleDate.getDate();
        let scheduleColumn: any;
        if (scheduleTaskColumns && scheduleTaskColumns.length) {
          scheduleColumn = scheduleTaskColumns.find(
            (schd: any) => schd.date == date
          );
          if (scheduleColumn) scheduleColumn.task.push(task);
        }
      }
    }
    if (scheduleTaskColumns && scheduleTaskColumns.length) {
      this.weekScheduleTaskColumns = [];
      let dataCount = 0,
        weekCount = 0;
      for (let column of scheduleTaskColumns) {
        if (dataCount < 7) {
          if (!this.weekScheduleTaskColumns[weekCount])
            this.weekScheduleTaskColumns[weekCount] = [];
          this.weekScheduleTaskColumns[weekCount].push(column);
        } else {
          dataCount = 0;
          weekCount++;
          this.weekScheduleTaskColumns[weekCount] = [];
          this.weekScheduleTaskColumns[weekCount].push(column);
        }
        dataCount++;
      }
      let selectedMonth = this.monthNames.findIndex(
        (mnth) => mnth === this.currentMonth
      );
      let weekIndex = 0;
      let weekGot = false;
      if (new Date().getMonth() == selectedMonth) {
        for (let week of this.weekScheduleTaskColumns) {
          if (week && week.length && !weekGot) {
            const weekFound = week.find(
              (weekData: any) => weekData.date == currentDate
            );
            if (weekFound && this.weekScheduleTaskColumns[weekIndex])
              weekGot = true;
            else if (!weekFound) weekIndex++;
          }
        }
      }
      this.scheduleTaskColumns = scheduleTaskColumns;
      let weekDataAdded = false;
      this.scheduleTaskColumns.forEach(
        (scheduleTaskColumns: any, index: number) => {
          if (!weekDataAdded) {
            this.scheduleTaskColumns[index] = weekIndex
              ? this.weekScheduleTaskColumns[weekIndex]
              : this.weekScheduleTaskColumns[0];
            weekDataAdded = true;
          } else this.scheduleTaskColumns[index] = [];
        }
      );
      this.weekIndex = weekIndex;
      this.taskRow = [];
      if (
        this.scheduleTaskColumns &&
        this.scheduleTaskColumns[0] &&
        this.scheduleTaskColumns[0].length
      ) {
        let maxTaskRow = 0;
        for (let task of this.scheduleTaskColumns[0]) {
          if (!task.task) task.task = [];
          if (maxTaskRow < task.task.length) maxTaskRow = task.task.length;
        }
        this.taskRow[0] = [];
        for (let i = 0; i < maxTaskRow; i++) this.taskRow[0].push(i);
      }
    }
  }

  changeWeek(index: number) {
    this.scheduleTaskColumns[0] = this.weekScheduleTaskColumns[index];
    this.weekIndex = index;
    this.taskRow = [];
    if (
      this.scheduleTaskColumns &&
      this.scheduleTaskColumns[0] &&
      this.scheduleTaskColumns[0].length
    ) {
      let maxTaskRow = 0;
      for (let task of this.scheduleTaskColumns[0]) {
        if (!task.task) task.task = [];
        if (maxTaskRow < task.task.length) maxTaskRow = task.task.length;
      }
      this.taskRow[0] = [];
      for (let i = 0; i < maxTaskRow; i++) this.taskRow[0].push(i);
    }
  }

  // public getLangWords() {
  //   this.pageId = this.baseApi.getCurrentMenuID();
  //   const userMenus = this.baseApi.getUserPermissionsSession();
  //   this.moduleId = userMenus.find(x => x.menuId === this.pageId)?.parentId;
  //   const key = {
  //     ModuleId: this.moduleId,
  //     PageId: this.pageId,
  //     LanguageId: this.translate.currentLang === 'en' ? 1 : this.translate.currentLang === 'ar' ? 2 : this.translate.currentLang === 'fr' ? 3 : this.translate.currentLang === 'sp' ? 4 : 1
  //   };
  //   this.translater.getLangWords(key).subscribe((res: any) => {
  //     let obj: any = {};
  //     res.tagList.map((elem: any) => {
  //       obj[elem.tagName] = elem.translatedValue;
  //     });
  //     this.langObj = obj;
  //   });
  // }

  public getLangWords() {
    this.pageId = this.baseApi.getCurrentMenuID();
    const userMenus = this.baseApi.getUserPermissionsSession();
    this.moduleId = userMenus.find((x) => x.menuId === this.pageId)?.parentId;
    const key = {
      ModuleId: this.moduleId,
      PageId: this.pageId,
      LanguageId:
        this.translate.currentLang === 'en'
          ? 1
          : this.translate.currentLang === 'ar'
            ? 2
            : this.translate.currentLang === 'fr'
              ? 3
              : this.translate.currentLang === 'sp'
                ? 4
                : 1,
    };
    this.translater.getLangWords(key).subscribe((res: any) => {
      let obj: any = {};
      res.tagList.map((elem: any) => {
        obj[elem.tagName] = elem.translatedValue;
      });
      this.langObj = obj;
      if (this.langObj) {
        this.gridApi.refreshHeader();
      }
    });
  }

   

  // getMonth() {
  //   const now = new Date();
  //   let selectedMonth: any = this.monthNames.findIndex(
  //     (mnth: any) => mnth == this.currentMonth
  //   );
  //   const days = new Date(now.getFullYear(), selectedMonth + 1, 0).getDate();
  //   let scheduleTaskColumns: any = [];
  //   this.currentYear = now.getFullYear();
  //   let currentDayAdded: any = 0;
  //   //let currentDay = selectedMonth == now.getMonth() ? now.getDay() : 1;
  //   let currentDay = new Date(this.currentYear, selectedMonth, 1).getDay(); // Get correct first day (e.g., 5 for Friday, August 1, 2025)
  //   let currentDate = now.getDate();
  //   for (let i = 1; i <= days; i++) {
  //     const fullDate = new Date();
  //     fullDate.setFullYear(this.currentYear);
  //     fullDate.setMonth(selectedMonth);
  //     fullDate.setDate(i);

  //     let column: any = { date: 0, day: '', weekOff: false };
  //     column.date = i;
  //     column.weekOff = currentDay == 5 || currentDay == 6 ? true : false;
  //     if (i == currentDate) {
  //       column.day = this.weekNames[currentDay - 1];
  //       currentDayAdded = true;
  //       currentDay++;
  //     } else if (currentDayAdded != 0 && currentDayAdded) {
  //       if (currentDay > 7) currentDay = 1;
  //       column.day = this.weekNames[currentDay - 1];
  //       currentDay++;
  //     }
  //     column.fullDate = fullDate;
  //     scheduleTaskColumns.push(column);
  //   }
  //   currentDay = now.getDay();
  //   for (let i = currentDate; i > 0; i--) {
  //     const fullDate = new Date();
  //     fullDate.setFullYear(this.currentYear);
  //     fullDate.setMonth(selectedMonth);
  //     fullDate.setDate(i);

  //     let column: any = { date: 0, day: '', weekOff: false };
  //     column.date = i;
  //     column.weekOff = currentDay == 5 || currentDay == 6 ? true : false;
  //     if (currentDay <= 0) currentDay = 7;
  //     column.day = this.weekNames[currentDay - 1];
  //     currentDay--;
  //     column.fullDate = fullDate;
  //     scheduleTaskColumns[i - 1] = column;
  //   }
  //   for (const row of this.scheduleTaskColumns) {
  //     if (row && row.length) {
  //       for (const scheduleColumn of row) {
  //         scheduleColumn.task = [];
  //       }
  //     }
  //   }
  //   let taskRow: any = [];
  //   if (this.taskList && this.taskList.length) {
  //     scheduleTaskColumns.map((schd: any) => (schd.task = []));
  //     for (const task of this.taskList) {
  //       const scheduleDate = new Date(task.TaskExpireTime);
  //       const date = scheduleDate.getDate();
  //       if (scheduleTaskColumns && scheduleTaskColumns.length) {
  //         let scheduleColumn: any = scheduleTaskColumns.find(
  //           (schd: any) => schd.date == date
  //         );
  //         if (scheduleColumn) scheduleColumn.task.push(task);
  //       }
  //     }
  //   }
  //   if (scheduleTaskColumns && scheduleTaskColumns.length) {
  //     this.scheduleTaskColumns = [];
  //     this.scheduleTaskColumns.push(scheduleTaskColumns.slice(0, 10));
  //     this.scheduleTaskColumns.push(scheduleTaskColumns.slice(10, 20));
  //     this.scheduleTaskColumns.push(scheduleTaskColumns.slice(20, 31));
  //   }
  //   let rowIndex = 0;
  //   for (let row of this.scheduleTaskColumns) {
  //     if (!taskRow[rowIndex]) taskRow[rowIndex] = 0;
  //     if (row && row.length) {
  //       for (let rowData of row) {
  //         if (rowData.task && rowData.task.length > taskRow[rowIndex])
  //           taskRow[rowIndex] = rowData.task.length;
  //       }
  //     }
  //     rowIndex++;
  //   }
  //   let index = 0;
  //   for (let row of taskRow) {
  //     this.taskRow[index] = [];
  //     for (let i = 0; i < row; i++) this.taskRow[index].push(i);
  //     index++;
  //   }
  // }




  getMonth() {
    const now = new Date();
    let selectedMonth: any = this.monthNames.findIndex(
      (mnth: any) => mnth == this.currentMonth
    ); // Use 7 directly (August, 0-indexed)
    const days = new Date(this.selectedYear, selectedMonth + 1, 0).getDate(); // 31 for August 2025
    let scheduleTaskColumns = [];
    let currentDay = new Date(this.selectedYear, selectedMonth, 1).getDay(); // First day of the month
    const currentDate = now.getMonth() === selectedMonth && now.getFullYear() === this.selectedYear ? now.getDate() : 1;
    // const days = new Date(now.getFullYear(), selectedMonth + 1, 0).getDate();
    // let scheduleTaskColumns: any = [];
    // this.currentYear = now.getFullYear();
    // let currentDayAdded: any = 0;
    // let currentDay = selectedMonth == now.getMonth() ? now.getDay() : 1;
    // let currentDate = now.getDate();
    for (let i = 1; i <= days; i++) {
      const fullDate = new Date(this.selectedYear, selectedMonth, i);
      let column = {
        date: i,
        day: this.weekNames[currentDay === 0 ? 6 : currentDay - 1], // Adjust for Sunday
        weekOff: currentDay === 5 || currentDay === 6, // Friday or Saturday
        fullDate: fullDate,
        task: [],
      };

      //let column: any = { date: 0, day: '', weekOff: false };
      // column.date = i;
      // column.weekOff = currentDay == 5 || currentDay == 6 ? true : false;
      // if (i == currentDate) {
      //   column.day = this.weekNames[currentDay - 1];
      //   currentDayAdded = true;
      //   currentDay++;
      // } else if (currentDayAdded != 0 && currentDayAdded) {
      //   if (currentDay > 7) currentDay = 1;
      //   column.day = this.weekNames[currentDay - 1];
      //   currentDay++;
      // }
      // column.fullDate = fullDate;
      // scheduleTaskColumns.push(column);
      scheduleTaskColumns.push(column);
      currentDay = (currentDay + 1) % 7;

    }
    currentDay = now.getDay();
    for (let i = currentDate; i > 0; i--) {
      const fullDate = new Date();
      fullDate.setFullYear(this.selectedYear);
      fullDate.setMonth(selectedMonth);
      fullDate.setDate(i);

      let column: any = { date: 0, day: '', weekOff: false };
      column.date = i;
      column.weekOff = currentDay == 5 || currentDay == 6 ? true : false;
      if (currentDay <= 0) currentDay = 7;
      column.day = this.weekNames[currentDay - 1];
      currentDay--;
      column.fullDate = fullDate;
      scheduleTaskColumns[i - 1] = column;
    }
    for (const row of this.scheduleTaskColumns) {
      if (row && row.length) {
        for (const scheduleColumn of row) {
          scheduleColumn.task = [];
        }
      }
    }
    //let taskRow: any = [];
    if (this.taskList && this.taskList.length) {
      //scheduleTaskColumns.map((schd: any) => (schd.task = []));
      for (const task of this.taskList) {
        const scheduleDate = new Date(task.TaskExpireTime);
        const date = scheduleDate.getDate();
        if (scheduleDate.getMonth() === selectedMonth && scheduleDate.getFullYear() === this.selectedYear) {
          let scheduleColumn = scheduleTaskColumns.find((schd) => schd.date === date);
          if (scheduleColumn) {
            if (!Array.isArray(scheduleColumn.task)) {
              scheduleColumn.task = [];
            }
            scheduleColumn.task.push(task);
          }
        }
      }
    }
    this.scheduleTaskColumns = [
      scheduleTaskColumns.slice(0, 10),
      scheduleTaskColumns.slice(10, 20),
      scheduleTaskColumns.slice(20, 31),
    ];
    let taskRow = [];
    let rowIndex = 0;
    for (let row of this.scheduleTaskColumns) {
      taskRow[rowIndex] = 0;
      // if (!taskRow[rowIndex]) taskRow[rowIndex] = 0;
      // if (row && row.length) {

      // }
      for (let rowData of row) {
        if (rowData.task && rowData.task.length > taskRow[rowIndex]) {
          taskRow[rowIndex] = rowData.task.length;
        }
      }
      rowIndex++;
    }
    this.taskRow = taskRow.map((count) => Array.from({ length: count }, (_, i) => i));
    console.log(this.scheduleTaskColumns, 'this.scheduleTaskColumns');
    console.log(taskRow, 'taskRow');

  }

  DisplayRightmenu(menuId: any, url: any): any {
    localStorage.setItem('O3RightMenuId', menuId);
    this.router
      .navigateByUrl('/', { skipLocationChange: true })
      .then(() => this.router.navigate([url]));
  }

  getUserList() {
    this.spinnerText = 'Fetching User Data';
    this.spinner.show();
    this.employeeService.getAllEmployees().subscribe(
      (res: any) => {
        this.userList = res;
        this.orgUserList = this.userList.slice();
        this.spinner.hide();
        this.getAllTechnicians();
        this.getPMTaskData('');
      },
      (err: any) => {
        this.spinner.hide();
        this.toaster.error('Error', err.message);
      }
    );
  }

  getAllTechnicians() {
    this.spinnerText = 'Fetching Technician Data';
    this.spinner.show();
    const data = {
      Group: this.groupSession?.groupCode,
      Plant: this.plantSession?.plantCode,
      RMPM: 'PM',
    };
    this.rmConfigurationService.getTechnician(data).subscribe(
      (res: any) => {
        this.spinner.hide();

        let techList: any = [];
        if (res.data && res.data.length) {
          for (let tech of res.data) {
            const chk = techList.find((t: any) => t == tech.UserId);
            if (!chk) techList.push(tech.UserId);
          }
          if (this.userList && this.userList.length)
            this.technicianList = [
              ...this.userList.filter((item: any) =>
                techList.includes(item.employeeCode)
              ),
            ];
        }
        this.filteredTechnicianList = [...this.technicianList];
      },
      (error: any) => {
        this.spinner.hide();
        this.toaster.error('Error', error.message);
      }
    );
  }

  searchValues(event: any, type: string) {
    const filter = event.target.value.toLowerCase();

    switch (type) {
      case 'technician':
      case 'tech': {
        const selectedTechIds = this.HeaderForm.value.userTechnician || [];
        this.filteredTechnicianList = this.technicianList.filter(tech =>
          tech.fullName.toLowerCase().includes(filter) ||
          selectedTechIds.includes(tech.employeeCode)   // ✅ keep selected
        );
        break;
      }

      case 'line': {
        const selectedLineIds = this.HeaderForm.value.line || [];
        this.filteredLineList = this.lineList.filter(line =>
          line.lineDesc.toLowerCase().includes(filter) ||
          selectedLineIds.includes(line.lineId)   // ✅ keep selected
        );
        break;
      }

      case 'machine': {
        const selectedMachineIds = this.HeaderForm.value.machine || [];
        this.filteredMachineList = this.machineList.filter(machine =>
          machine.unitDesc.toLowerCase().includes(filter) ||
          selectedMachineIds.includes(machine.unitId)   // ✅ keep selected
        );
        break;
      }

      case 'component': {
        const selectedComponentIds = this.HeaderForm.value.component || [];
        this.filteredComponentList = this.componentList.filter(component =>
          component.ComponentName?.toLowerCase().includes(filter) ||
          selectedComponentIds.includes(component.ComponentID)   // ✅ keep selected
        );
        break;
      }

      case 'task': {
        const selectedTaskIds = this.HeaderForm.value.task || [];
        this.filteredTaskList = this.taskList.filter(task =>
          task.Description.toLowerCase().includes(filter) ||
          selectedTaskIds.includes(task.Task_ID)   // ✅ keep selected
        );
        break;
      }

      case 'frequency': {
        const selectedFreqIds = this.HeaderForm.value.frequency || [];
        this.filteredFrequencyList = this.frequencyList.filter(freq =>
          freq.Name.toLowerCase().includes(filter) ||
          selectedFreqIds.includes(freq.ID)   // ✅ keep selected
        );
        break;
      }

      case 'type': {
        const selectedTypeIds = this.HeaderForm.value.type || [];
        this.filteredTypeList = this.TaskTypeList.filter(type =>
          type.Name.toLowerCase().includes(filter) ||
          selectedTypeIds.includes(type.ID)   // ✅ keep selected
        );
        break;
      }

      case 'activity': {
        const selectedActivityIds = this.HeaderForm.value.activity || [];
        this.WOTypeFiltListHeaderForm = this.WOTypeListHeaderForm.filter(act =>
          act.Name.toLowerCase().includes(filter) ||
          selectedActivityIds.includes(act.ID)   // ✅ keep selected
        );
        break;
      }

      case 'taskStatus': {
        const selectedStatusIds = this.HeaderForm.value.taskStatus || [];
        this.TaskStatusListFiltered = this.TaskStatusList.filter(act =>
          act.Name.toLowerCase().includes(filter) ||
          selectedStatusIds.includes(act.Name)   // ✅ keep selected
        );
        break;
      }

    }
  }

  // This ensures Angular knows how to check selected values
  compareFn(o1: any, o2: any): boolean {
    return o1 == o2;
  }


  onYearChange(event: any) {
    if (this.currentMonth && this.selectedYear) {
      this.getTaskList();
    }
  }

  onMonthChange(event: any) {
    if (this.currentMonth && this.selectedYear) {
      this.getTaskList();
    }
  }

  getTaskList() {
    this.spinnerText = 'Fetching Task Data';
    this.spinner.show();
    let month = this.monthNames.findIndex((mnth) => mnth === this.currentMonth);
    const data = {
      Group: this.groupSession?.groupCode,
      Plant: this.plantSession?.plantCode,
      RMPM: 'PM',
      TechId:
        this.headerData.technician === 'ALL'
          ? 'ALL'
          : this.headerData.technician,
      month: ++month,
      year: this.selectedYear,
    };
    this.prevTaskService.getPMTechnicianTask(data).subscribe(
      (res: any) => {
        this.spinner.hide();
        if (res.status) {
          this.taskList = res.data;
          this.rowData = this.taskList.slice();
          if (this.headerData.WeekMonth == 1) this.getWeek();
          else this.getMonth();
          this.getAllTechnicians();
        } else this.toaster.error('Error', res.message);
      },
      (err: any) => {
        this.spinner.hide();
        this.toaster.error('Error', err.message);
      }
    );
  }
  getPMTechnicianTaskPool() {
    this.spinnerText = 'Fetching Task Data';
    this.spinner.show();
    const data: any = {
      Group: this.groupSession?.groupCode,
      Plant: this.plantSession?.plantCode,
      RMPM: 'PM',
      TechId: 'ALL',
    };

    // Only add filters if arrays are empty or null
    if (this.HeaderForm.value.task.length > 0) {
      data.TaskId = this.HeaderForm.value.task.join(',');
    }
    if (this.HeaderForm.value.line.length > 0) {
      data.LineId = this.HeaderForm.value.line.join(',');
    }
    if (this.HeaderForm.value.machine.length > 0) {
      data.UnitId = this.HeaderForm.value.machine.join(',');
    }
    if (this.HeaderForm.value.component.length > 0) {
      data.ComponentId = this.HeaderForm.value.component.join(',');
    }
    if (this.HeaderForm.value.type.length > 0) {
      data.TaskTypeId = this.HeaderForm.value.type.join(',');
    }
    if (this.HeaderForm.value.frequency.length > 0) {
      data.FrequId = this.HeaderForm.value.frequency.join(',');
    }
    if (this.HeaderForm.value.activity.length > 0) {
      data.ActivityId = this.HeaderForm.value.activity.join(',');
    }
    if (this.HeaderForm.value.taskStatus.length > 0) {
      data.TypeStatus = this.HeaderForm.value.taskStatus.join(',');
    }
    if (this.HeaderForm.value.userTechnician.length > 0) {
      data.technician = this.HeaderForm.value.userTechnician.join(',');
    }

    // If date range should be included only when valid:
    const FromDate = this.HeaderForm.value.dateRange;
    const ToDate = this.HeaderForm.value.endDate;
    if (FromDate && ToDate) {
      data.FromDate = moment(FromDate._d).format('YYYY-MM-DD');

      data.ToDate = moment(ToDate._d).format('YYYY-MM-DD');
    }
    this.prevTaskService.getPMTechnicianTaskPool(data).subscribe(
      (res: any) => {
        this.spinner.hide();
        if (res.status) {
          this.taskPoolList = res.data;
          this.rowPoolData = this.taskPoolList.slice();
          if (this.headerData.WeekMonth == 1) this.getWeek();
          else this.getMonth();
        } else this.toaster.error('Error', res.message);
      },
      (err: any) => {
        this.spinner.hide();
        this.toaster.error('Error', err.message);
      }
    );
  }

  applyFilters() {
    this.getPMTechnicianTaskPool();
  }
  getMachineComponentAndTask() {
    if (this.HeaderForm.value.line?.length) {
      const selectedLineNames: string[] = this.HeaderForm.value.line;
      const matchedPlIdsString = selectedLineNames.join(',');
      this.GetUnitsByLineId(matchedPlIdsString);
    }

    // Machine filter
    if (this.HeaderForm.value.machine?.length) {
      const selectedMachineNames: string[] = this.HeaderForm.value.machine;
      const matchedPuIdsString = selectedMachineNames.join(',');
      this.GetComponentList(matchedPuIdsString);
    }

    // Component filter
    if (this.HeaderForm.value.component?.length) {
      const selectedcomponentIds: string[] = this.HeaderForm.value.component;
      const componentIdsString = selectedcomponentIds.join(',');
      this.getPMTechnicianTaskByComponent(componentIdsString);
    }
  }
  changeCalendar() {
    if (this.headerData.WeekMonth == 1) this.getWeek();
    else this.getMonth();
  }

  reScheduleTaskFromPool() {
    const selectedRows = this.gridOptions.api.getSelectedNodes()
      .filter(node => node.displayed) // only visible after filter
      .map(node => node.data);

    if (!selectedRows || selectedRows.length === 0) {
      this.toaster.warning('Please select at least one task from the filtered data', 'Warning');
      return;
    }

    const taskData = {
      task: selectedRows,
      rowIndex: 0,
      technicianList: this.filteredTechnicianList,
    };

    // Ensure first task month is updated
    taskData.task[0].month = this.currentMonth;
    taskData.rowIndex = 0;

    // Get technician name for first task
    const techName = this.filteredTechnicianList.find(
      (tech: any) => tech.employeeCode == taskData.task[0].TaskBy
    );
    taskData.task[0].TechnicianName = techName ? techName.fullName : '';
    // taskData.technicianList = this.filteredTechnicianList;
    let dialogRef = this.dialog.open(RescheduleTaskDialogComponent, {
      width: '97vw',
      height: '600px',
      data: taskData,
    });

    // dialogRef.afterClosed().subscribe((result) => {
    //   if (result) {
    //     this.spinnerText = 'Rescheduling Task ...';
    //     this.spinner.show();
    //     this.prevTaskService.resheduleTaskList(result).subscribe(
    //       (res: any) => {
    //         this.spinner.hide();
    //         this.getTaskList();
    //         if (res.status) {
    //           this.toaster.success(res.message, 'Success');
    //         } else this.toaster.error(res.message, 'Error');
    //       },
    //       (err: any) => {
    //         this.spinner.hide();
    //         this.toaster.error(err.ErrorMessage, 'Error');
    //       }
    //     );
    //   }
    // });

    dialogRef.afterClosed().subscribe((result) => {
      this.selectedRowCount = 0;
      this.gridApi.deselectAll();
      this.refreshTaskData();
    });
  }

  refreshTaskData() {
    this.spinnerText = 'Refreshing Task Data...';
    this.spinner.show();
    this.getTaskList();

    this.getPMTechnicianTaskPool();

    this.spinner.hide();
  }

  reScheduleTask(rowIndex: number, taskData: any) {
    taskData.task[rowIndex].month = this.currentMonth;
    taskData.rowIndex = rowIndex;
    const techName = this.filteredTechnicianList.find(
      (tech: any) => tech.employeeCode == taskData.task[rowIndex].TaskBy
    );
    taskData.task[rowIndex].TechnicianName = techName ? techName.fullName : '';
    taskData.technicianList = this.filteredTechnicianList;
    let dialogRef = this.dialog.open(ScheduleTaskDialogComponent, {
      width: '700px',
      height: '500px',
      data: taskData,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.spinnerText = 'Rescheduling Task ...';
        this.spinner.show();
        this.prevTaskService.resheduleTask(result).subscribe(
          (res: any) => {
            this.spinner.hide();
            this.getTaskList();
            if (res.status) {
              this.toaster.success(res.message, 'Success');
            } else this.toaster.error(res.message, 'Error');
          },
          (err: any) => {
            this.spinner.hide();
            this.toaster.error(err.ErrorMessage, 'Error');
          }
        );
      }
    });
  }

  getPMTaskData(type: any) {
    this.getTechnician();
    this.getWOType();
    this.getTreeMasterData(type);
  }

  getTreeMasterData(type: any) {
    const data = {
      PlantCode: this.plantSession?.plantCode,
      GroupCode: this.groupSession?.groupCode,
    };
    this.spinner.show();
    this.prevConfigurationService.GetTreeMasterData(data).subscribe(
      (res: any) => {
        this.spinner.hide();
        this.LineAllList = [];
        this.LineList = [];
        this.LineFilterList = [];
        this.UnitAllList = [];
        this.UnitList = [];
        this.UnitFilterList = [];
        this.AssemblyAllList = [];
        this.AssemblyList = [];
        this.AssemblyFilterList = [];
        this.SubAssemblyAllList = [];
        this.SubAssemblyList = [];
        this.SubAssemblyFilterList = [];
        this.ComponentAllList = [];
        this.ComponentList = [];
        this.ComponentFilterList = [];
        this.LineAllList = res.Line;
        this.LineList = res.Line;
        this.UnitAllList = res.Unit;
        this.AssemblyAllList = res.Assembly;
        this.SubAssemblyAllList = res.SubAssembly;
        this.ComponentAllList = res.Component;
        this.LineFilterList = this.LineList.slice();
        if (this.LineFilterList && this.LineAllList.length) {
          this.PMTask.line = this.LineAllList[0].PL_Id
            ? this.LineAllList[0].PL_Id
            : '';

          this.setUnitList('notChange');
          this.setAssemblyList('notChange');
          this.setSubAssemblyList('notChange');
          this.setComponentList('notChange');
        }
        if (type === 'change') {
          this.setUnitList('notChange');
        }
      },
      (error: any) => {
        this.spinner.hide();
        this.toaster.error('Error', error.ErrorMessage);
      }
    );
  }

  setUnitList(type: any) {
    this.UnitList = [];
    this.UnitFilterList = [];
    this.AssemblyList = [];
    this.AssemblyFilterList = [];
    this.SubAssemblyList = [];
    this.SubAssemblyFilterList = [];
    this.ComponentList = [];
    this.ComponentFilterList = [];
    let unitList = this.UnitAllList.filter(
      (unit: any) => unit.PL_Id == this.PMTask.line
    );

    if (unitList && unitList.length) {
      this.UnitList = unitList;
      this.UnitFilterList = this.UnitList.slice();
      this.PMTask.units = this.UnitFilterList[0].PU_Id
        ? this.UnitFilterList[0].PU_Id
        : '';

      if (type == 'change') {
        this.PMTask.assembly = '';
        this.PMTask.subAssembly = '';
        this.PMTask.component = '';
        this.setAssemblyList('change');
      } else {
        this.setAssemblyList('notchange');
      }
    }
  }

  setAssemblyList(type: any) {
    this.AssemblyList = [];
    this.AssemblyFilterList = [];
    this.SubAssemblyList = [];
    this.SubAssemblyFilterList = [];
    this.ComponentList = [];
    this.ComponentFilterList = [];
    let assemblyList = this.AssemblyAllList.filter(
      (assembly: any) => assembly.PU_Id == this.PMTask.units
    );

    if (assemblyList && assemblyList.length) {
      this.AssemblyList = assemblyList;
      this.AssemblyFilterList = this.AssemblyList.slice();
      this.PMTask.assembly = this.AssemblyFilterList[0].Assbly_Id
        ? this.AssemblyFilterList[0].Assbly_Id
        : '';
      if (type == 'change') {
        this.PMTask.subAssembly = '';
        this.PMTask.component = '';
        this.setSubAssemblyList('change');
      } else {
        this.setSubAssemblyList('notchange');
      }
    }
  }

  setSubAssemblyList(type: any) {
    this.SubAssemblyList = [];
    this.SubAssemblyFilterList = [];
    this.ComponentList = [];
    this.ComponentFilterList = [];
    let subassemblyList = this.SubAssemblyAllList.filter(
      (subassembly: any) => subassembly.Assbly_Id == this.PMTask.assembly
    );

    if (subassemblyList && subassemblyList.length) {
      this.SubAssemblyList = subassemblyList;
      this.SubAssemblyFilterList = this.SubAssemblyList.slice();
      this.PMTask.subAssembly = this.SubAssemblyFilterList[0].SAssbly_Id
        ? this.SubAssemblyList[0].SAssbly_Id
        : '';

      if (type == 'change') {
        this.PMTask.component = '';
        this.setComponentList('change');
      } else {
        this.setComponentList('notchange');
      }
    }
  }

  setComponentList(type: any) {
    this.ComponentList = [];
    this.ComponentFilterList = [];
    let componentList = this.ComponentAllList.filter(
      (component: any) => component.SAssbly_Id == this.PMTask.subAssembly
    );
    if (type == 'change') {
      this.PMTask.component = '';
    } else {
      if (componentList && componentList.length) {
        this.ComponentList = componentList;
        this.ComponentFilterList = this.ComponentList.slice();
        this.PMTask.component = this.ComponentFilterList[0].ComponentId
          ? this.ComponentList[0].ComponentId
          : '';
      }
    }

    if (componentList && componentList.length) {
      this.ComponentList = componentList;
      this.ComponentFilterList = this.ComponentList.slice();
      if (type == 'change' && componentList.length) {
        this.PMTask.component = this.ComponentList[0].ComponentId;
      }
    }
  }

  setMaintenanceType() {
    const obj = this.TaskTypeList.find(
      (tt: any) => tt.ID == this.PMTask.TaskType
    );
    this.PMTask.MaintenanceType =
      obj && obj.MaintenanceType ? obj.MaintenanceType : '';
  }

  getTechnician() {
    this.spinnerText = 'Fetching Technician Data';
    this.spinner.show();
    const data = {
      Plant: this.plantSession?.plantCode,
      Group: this.groupSession?.groupCode,
      RMPM: 'PM',
    };
    this.RMConfigurationService.getTechnician(data).subscribe(
      (res: any) => {
        this.spinner.hide();
        this.TechnicianList = res.data;
        this.loadTechnicianList();
        let Technician: any = { Name: [] };
        this.userList = [...this.orgUserList];
        this.filterTechnicianList = [];

        if (this.TechnicianList && this.TechnicianList.length) {
          this.TechnicianList1 = this.TechnicianList;
          this.TechnicianListFilter = this.TechnicianList1.slice();
          this.PMTask.Technician = this.TechnicianListFilter[0].UserId
            ? this.TechnicianListFilter[0].UserId
            : '';
        }

        const uniqueTechList = [];
        const uniqueTechID = [];

        const unique = this.TechnicianList.filter((element) => {
          const isDuplicate = uniqueTechID.includes(element.UserId);

          if (!isDuplicate) {
            uniqueTechID.push(element.UserId);
            uniqueTechList.push(element);

            return true;
          }

          return false;
        });
        this.userList.sort(function (a, b) {
          return a.fullName.localeCompare(b.fullName);
        });
        for (const tech of uniqueTechList) {
          const user = this.userList.find(
            (user: any) => user.employeeCode == tech.UserId
          );
          if (user) {
            tech.UserName = user.fullName;
            Technician.Name.push(tech.UserId);
            this.filterTechnicianList.push({
              UserId: tech.UserId,
              UserName: tech.UserName,
            });
          }
        }
        this.TechnicianFiltList =
          this.filterTechnicianList && this.filterTechnicianList.length
            ? this.filterTechnicianList.slice()
            : [];
      },
      (error: any) => {
        this.spinner.hide();
        this.toaster.error('Error', error.message);
      }
    );
  }
  getWOType() {
    this.spinnerText = 'Fetching WOType Data';
    this.spinner.show();
    const data = {
      Plant: this.plantSession?.plantCode,
      Group: this.groupSession?.groupCode,
      RMPM: 'PM',
    };
    this.RMConfigurationService.getWOType(data).subscribe(
      (res: any) => {
        this.spinner.hide();
        this.WOTypeList = res.woTypeList;
        if (this.WOTypeList && this.WOTypeList.length) {
          this.WOTypeList1 = this.WOTypeList;
          this.WOTypeFilterList = this.WOTypeList1.slice();
          this.PMTask.WOType = this.WOTypeFilterList[0].ID
            ? this.WOTypeFilterList[0].ID
            : '';
        }
        this.WOTypeFiltList =
          this.WOTypeList && this.WOTypeList.length
            ? this.WOTypeList.slice()
            : [];
        this.WOTypeListHeaderForm =
          this.WOTypeList && this.WOTypeList.length
            ? this.WOTypeList.slice()
            : [];
        this.WOTypeFiltListHeaderForm =
          this.WOTypeList && this.WOTypeList.length
            ? this.WOTypeList.slice()
            : [];
      },
      (error: any) => {
        this.spinner.hide();
        this.toaster.error('Error', error.message);
      }
    );
  }
  getFrequency() {
    this.spinnerText = 'Fetching Frequency Data';
    this.spinner.show();

    const data = {
      Plant: this.plantSession?.plantCode,
      Group: this.groupSession?.groupCode,
    };
    this.PrevConfigurationService.getPrevFrequency(data).subscribe(
      (res: any) => {
        this.frequencyList = res.frequencyList;
        if (this.frequencyList && this.frequencyList.length) {
          this.FrequencyList = this.frequencyList;
          this.filteredFrequencyList = this.FrequencyList.slice();
        }
        this.spinner.hide();
      },
      (err: any) => {
        this.spinner.hide();
      }
    );
  }
  getTaskType() {
    this.spinnerText = 'Fetching TaskType Data';
    this.spinner.show();
    const data = {
      Plant: this.plantSession?.plantCode,
      Group: this.groupSession?.groupCode,
    };
    this.PrevConfigurationService.getTaskType(data).subscribe(
      (res: any) => {
        this.TaskTypeList = res.taskTypeList;
        this.filteredTypeList = this.TaskTypeList.slice();
        this.spinner.hide();
      },
      (err: any) => {
        this.spinner.hide();
      }
    );
  }
  // getPMTechnicianTaskByComponent(componentIds: string) {
  //   this.spinnerText = 'Fetching TaskType Data';
  //   this.spinner.show();
  //   const data = {
  //     plantCode: this.plantSession?.plantCode,
  //     groupCode: this.groupSession?.groupCode,
  //     componentId: componentIds,
  //   };
  //   this.PrevConfigurationService.getPMTechnicianTaskByComponent(data).subscribe(
  //     (res: any) => {
  //       this.allTaskList = res.Table;
  //       this.filteredTaskList = this.allTaskList.slice();
  //       this.spinner.hide();
  //     },
  //     (err: any) => {
  //       this.spinner.hide();
  //     }
  //   );
  // }

  getPMTechnicianTaskByComponent(componentIds: string) {
    this.spinnerText = 'Fetching Task Data';
    this.spinner.show();
    const data = {
      plantCode: this.plantSession?.plantCode,
      groupCode: this.groupSession?.groupCode,
      componentId: componentIds,
    };
    this.PrevConfigurationService.getPMTechnicianTaskByComponent(
      data
    ).subscribe(
      (res: any) => {
        this.spinner.hide();
        console.log('Task Response:', res); // Debug the response
        if (res && res.Table && Array.isArray(res.Table)) {
          this.allTaskList = res.Table;
          this.taskList = res.Table; // Ensure taskList is updated
          this.filteredTaskList = [...this.taskList]; // Initialize filteredTaskList
        } else {
          this.allTaskList = [];
          this.taskList = [];
          this.filteredTaskList = [];
          this.toaster.warning('No tasks found for selected component');
        }
      },
      (err: any) => {
        this.spinner.hide();
        this.toaster.error('Error fetching tasks', err.message);
        this.allTaskList = [];
        this.taskList = [];
        this.filteredTaskList = [];
      }
    );
  }

  setFrequencyDuration() {
    const obj = this.frequencyList.find(
      (freq: any) => freq.ID == this.PMTask.Frequency
    );
    this.FreqDuration = obj.Duration;
  }

  addPMTask() {
    let dialogRef = this.dialog.open(this.pmTaskForm, {
      disableClose: true,
      minHeight: '60%',
      width: '90%',
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
      } else {
      }
    });
  }

  openTreeModal() {
    this.unitPickerIsOpen = true;
    this.isPickFromUnit = true;
  }

  setUnit(event: any) {
    this.unitPickerIsOpen = false;
    if (event.Level == 'Line') {
      return;
      this.PMTask.line = event.line;
    } else if (event.Level == 'Unit') {
      this.PMTask.line = event.line;
      this.PMTask.units = event.units;
    } else if (event.Level == 'Assembly') {
      this.PMTask.line = event.line;
      this.PMTask.units = event.units;
      this.PMTask.assembly = event.assembly;
    } else if (event.Level == 'SubAssembly') {
      this.PMTask.line = event.line;
      this.PMTask.units = event.units;
      this.PMTask.assembly = event.assembly;
      this.PMTask.subAssembly = event.subAssembly;
    } else if (event.Level == 'Component') {
      this.PMTask.line = event.line;
      this.PMTask.units = event.units;
      this.PMTask.assembly = event.assembly;
      this.PMTask.subAssembly = event.subAssembly;
      this.PMTask.component = event.component;
    }
    this.PMTask.displayMachine = event.displayMachine;
  }

  openFile() {
    this.fileInput.nativeElement.click();
  }

  readFile(event: any) {
    const files = event.target.files;
    this.FileList.push(event.target.files[0]);
    if (files) {
      for (let file of files) {
        if (file.type.match('image.*')) {
          this.fileType = 'image';
        } else if (file.type.match('video.*')) {
          this.fileType = 'video';
        } else if (file.type.match('application.*')) {
          this.fileType = 'application';
        }
        let reader = new FileReader();
        reader.onload = (e: any) => {
          this.imageSrc = e.target.result;
          this.FileData.push({
            FileType: this.fileType,
            ImageSrc: this.imageSrc,
          });
        };
        reader.readAsDataURL(file);
      }
    }
  }

  removeFile(i: any) {
    this.FileData.splice(i, 1);
    this.FileList.splice(i, 1);
  }

  TaskOnSubmit() {
    if (this.PMTaskForm.invalid) {
      this.toaster.warning('Warning', 'Please Fill All Required Fields');
      return;
    } else {
      this.PMTask.CreatedAt = new Date();
      this.PMTask.CreatedBy = this.userSession?.userCode;
      let NextDate = new Date();
      NextDate.setDate(NextDate.getDate() + this.FreqDuration);
      this.PMTask.NextScheduleAt = NextDate;
      this.PMTask.FromTaskDate = new Date(this.PMTask.FromTaskDate);
      if (!this.PMTask.assembly) this.PMTask.assembly = null;
      if (!this.PMTask.subAssembly) this.PMTask.subAssembly = null;
      if (!this.PMTask.component) this.PMTask.component = null;
      this.spinner.show();
      const Formvalues = new FormData();
      for (const file of this.FileList)
        Formvalues.append('File', file, file.name);
      Formvalues.append('Data', JSON.stringify(this.PMTask));

      this.PrevConfigurationService.addPrevTask(Formvalues).subscribe(
        (res: any) => {
          if (res.status) {
            this.spinner.hide();
            this.getTaskList();
            this.PMTaskForm.reset();
            this.toaster.success(
              res.message || `Data Inserted Successfully`,
              'Success',
              {
                timeOut: 3000,
              }
            );
          }
        },
        (err: any) => {
          this.spinner.hide();
          this.toaster.error(err.message || `Server Error`, 'Error', {
            timeOut: 3000,
          });
        }
      );
      this.dialog.closeAll();
    }
  }

  addUserWiseNotification(ids: any, techTask: any, type: any) {
    let data: any;
    if (type == 'Reschedule') {
      data = {
        userId: techTask.Task.CreatedBy, // multiple user ids send [104,105,7,9]
        desc: `Technician Task ID ${ids} Are Rescheduled`,
        title: 'Task Rescheduled',
        createdBy: JSON.parse(localStorage.user).UserId,
      };
    } else {
      const userIds = [techTask[0].Task.CreatedBy, techTask[1].Task.CreatedBy];
      data = {
        userId: userIds, // multiple user ids send [104,105,7,9]
        desc: `Technician Task ID ${ids[0]} And ${ids[1]} Are Swapped`,
        title: 'Task Swapped',
        createdBy: JSON.parse(localStorage.user).UserId,
      };
    }
    this.spinnerText = 'Adding User Wise Notification';
    this.spinner.show();
    this.PrevConfigurationService.addUserWiseNotification(data).subscribe(
      (res: any) => {
        this.spinner.hide();
        if (res.status) {
          this.toaster.success('Success', res.message);
        }
      },
      (error: any) => {
        this.spinner.hide();
        this.toaster.error('Error', error.ErrorMessage);
      }
    );
  }
}
